import { Button, Card, Col, Container, Form, Table } from "react-bootstrap";
import MainMenu from "../../../modules/public/mainMenu/mainMenu";

import style from "./Returned.module.css";
import { useEffect } from "react";
import { useState } from "react";
import { getAuthMethod } from "../../../modules/helper";
import Laoder from "../../../components/loading/Loader";
import PaginateCard from "../../../components/PaginateCard";
import useUserInformation from "../../../hooks/useUserInformation";
import PrintLink from "../../../components/shipment/Factor/PrintLink";

function Returned() {
  const [filter, setFilter] = useState({
    numberItems: 10,
    pageNumber: 1,
    barname: 0,
  });
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [shipments, setShipments] = useState([]);

  const { agent } = useUserInformation();
  if (!agent) {
    window.location.replace("/login");
  }

  const paymentMethod = (isCod, amountCOD) => {
    if (isCod) {
      if (amountCOD > 0) {
        return "پرداخت در محل COD";
      } else {
        return "پسکرایه";
      }
    } else {
      return "پیشکرایه";
    }
  };

  const getData = async () => {
    setIsLoading(true);
    const response = await getAuthMethod(
      `/agent/v1/returned-shipment/${agent.id}?numberitems=${
        filter.numberItems
      }&numberpage=${filter.pageNumber}${
        filter.barname ? "&barname=" + filter.barname : ""
      }`
    );

    if (response.status === 200) {
      setShipments(response.data.data);
      setCount(response.data.count);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, [filter.numberItems, filter.pageNumber]);

  const serviceShare = item => {
    if (item.item.componyId === 1) {
      return 0;
    }

    const value = item.wallet
      .find(wallet => {
        if (wallet.userId === item.item.componyId) {
          return true;
        }
      })
      ?.amount?.toLocaleString();

    if (!value) return 0;

    return value;
  };

  const handleSubmit = e => {
    e.preventDefault();
    getData();
  };

  const getValue = item => {
    if (!item) return 0;
    return item;
  };

  const table = (
    <div className="w-100 overflow-x-scroll px-2 my-3">
      <Table className={"w-100 " + style.table} bordered={true} striped>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>شماره بارنامه</th>
            <th>تاریخ</th>
            <th>سرویس دهنده</th>
            <th>نوع پرداخت</th>
            <th>مبلغ فاکتور</th>
            <th>سهم سرویس دهنده</th>
            <th>سهم نماینده</th>
            <th>
              مجموع مبلغ دریافتی از فرستنده&nbsp;
              <sub>(ریال)</sub>
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading === true && (
            <tr>
              <td colSpan={9}>
                <Laoder />
              </td>
            </tr>
          )}
          {isLoading === false &&
            shipments.map((item, idx) => (
              <tr key={idx}>
                <td>
                  {idx + (filter.pageNumber - 1) * filter.numberItems + 1}
                </td>
                <td>
                  <PrintLink ids={[item.item.id]}>
                    {item.item.numberParcel}
                  </PrintLink>
                </td>
                <td>{item.date + " " + item.time}</td>
                <td>{item.company.name}</td>
                <td>{paymentMethod(item.item.isCod, item.item.amountCOD)}</td>
                <td>
                  {(
                    item.item.realPayable + item.item.amountCOD
                  ).toLocaleString()}
                </td>
                <td>{serviceShare(item)}</td>

                <td>
                  {getValue(
                    item.wallet
                      .find(wallet => {
                        if (wallet.userId !== item.item.componyId) {
                          if (wallet.type === "واریز") {
                            return true;
                          }
                        }
                        return false;
                      })
                      ?.amount?.toLocaleString()
                  )}
                </td>

                <td>
                  <span>
                    {getValue(
                      item.wallet
                        .find(wallet => {
                          if (wallet.userId !== item.item.componyId) {
                            if (wallet.type === "برداشت") {
                              return true;
                            }
                          }
                        })
                        ?.amount?.toLocaleString()
                    )}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );

  const options = (
    <form className="my-3 d-flex flex-wrap" onSubmit={handleSubmit}>
      <Col xs={6} sm={4} md={3}>
        <Form.Label>تعداد نمایش</Form.Label>
        <Form.Select
          value={filter.numberItems}
          onChange={e =>
            setFilter({ pageNumber: 1, numberItems: parseInt(e.target.value) })
          }
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </Form.Select>
      </Col>

      <Col xs={6} sm={4} md={3}>
        <Form.Label>بارنامه:</Form.Label>
        <Form.Control
          type="number"
          onChange={e =>
            setFilter(cur => ({ ...cur, barname: parseInt(e.target.value) }))
          }
        />
      </Col>

      <Col xs={6} sm={4} md={3} className="d-flex justify-content-end me-auto">
        <Button type="submit" className="align-self-end">
          فیلتر
        </Button>
      </Col>
    </form>
  );

  const paginate = (
    <PaginateCard
      numberItems={filter.numberItems}
      count={count}
      numberPage={filter.pageNumber}
      onIndexChoose={number =>
        setFilter(cur => ({ ...cur, pageNumber: number }))
      }
    />
  );

  const total = (
    <Container>
      <Card className="w-100 my-5">
        <h5>برگشتی</h5>
        {options}
        {table}
        {paginate}
      </Card>
    </Container>
  );

  return <MainMenu data={total} />;
}

export default Returned;
